<template>
    <div class="page-designer">
        <emulator />
    </div>
</template>

<script>
import metaCheck from '@common/mixins/metaCheck'

export default {
    name: 'Designer',
    mixins: [metaCheck],
    methods: {
   
    },
}
</script>

<style lang="less" scoped>
.page-designer {
    height: 100%;
}
</style>
